import React, { Component, MouseEvent } from "react";
import cx from "classnames";

import { Button } from "components/base";

interface Props {
  className: string;
  textClassName: string;
  label?: string;
  checked: boolean;
  onClick(e: MouseEvent<HTMLInputElement>): void;
  ariaLabel: string;
  variant?: "primary";
  children?: React.ReactNode;
  disabled: boolean;
  style: React.CSSProperties;
}

const defaultProps = {
  className: "",
  textClassName: "",
  checked: false,
  onClick: () => {},
  disabled: false,
  style: {}
};

class Radio extends Component<Props> {
  static defaultProps = defaultProps;

  render() {
    const {
      className,
      textClassName,
      label,
      checked,
      onClick,
      ariaLabel,
      variant,
      children,
      disabled,
      style
    } = this.props;

    return (
      <Button
        ariaLabel={ariaLabel}
        onClick={onClick}
        className={cx(
          "Radio relative p0 flex flex-row items-center",
          className,
          {
            [`Radio--style-${variant}`]: !!variant,
            "Radio--checked": checked
          }
        )}
        disabled={disabled}
        style={style}
      >
        {!!children && !label ? (
          children
        ) : (
          <label className={cx("pointer", textClassName)}>{label}</label>
        )}
      </Button>
    );
  }
}

export default Radio;
